import { CircleCheck } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/Dialog';
import type { EventLocationType } from '@/lib/types/events.types';
import { EVENTS_STRINGS } from '../constants/events-strings';
import { JoinDetailsPanel } from './JoinDetailsPanel';

const S = EVENTS_STRINGS.REGISTERED;

export interface RegistrationConfirmedDialogProps {
  open: boolean;
  onClose: () => void;
  locationType: EventLocationType | null | undefined;
  /** The join link or address; omitted while it loads or when the event has none. */
  locationDetails: string | null | undefined;
  /** Overrides the email line, e.g. to name the address a visitor typed. */
  emailNote?: string;
}

/**
 * The clear confirmation that replaced the registration snackbar (MYN-329):
 * a check mark, "You're registered", how to join, and that an email is on its
 * way. Shared by the member and the logged-out registration flows.
 */
export function RegistrationConfirmedDialog({
  open,
  onClose,
  locationType,
  locationDetails,
  emailNote = S.EMAIL_SENT,
}: RegistrationConfirmedDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => !next && onClose()}
      title={S.TITLE}
      description={emailNote}
      align="center"
      headerIcon={<CircleCheck size={48} className="text-green" aria-hidden />}
      footer={
        <Button variant="green" onClick={onClose}>
          {S.DONE}
        </Button>
      }
    >
      {locationDetails && (
        <JoinDetailsPanel locationType={locationType ?? null} locationDetails={locationDetails} />
      )}
    </Dialog>
  );
}
